module.exports = __webpack_public_path__ + "img/arrow-left.0f85fbfe.svg";